import { Component, ViewEncapsulation, OnInit, ElementRef } from '@angular/core';
import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';
import { PlessViewHelperSub } from '../../../commons/kymw00/pless-view-helper-sub';
import { PlessDialogServiceSub } from '../../../commons/kymw00/pless-dialog-service-sub';

import { PageTemplateModel } from '../kymw2400/vo/page-template.model';
import { CreateNewPageService } from './api-services/create-new-page.service';

/**
 * ページテンプレート新規作成画面を管理するクラス
 *
 * @export KYMW2401Component
 * @class KYMW2401Component
 */
@Component({
  selector: 'app-kymw2401',
  templateUrl: 'kymw2401.component.html',
  styleUrls: ['kymw2401.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class KYMW2401Component extends PlessViewHelperSub implements OnInit {
  // ウィンドウを閉じる際の処理
  public closeFunction: Function = null;

  public pageTemplateName = String('');
  public pageAreaX = String('0');
  public pageAreaY = String('0');
  public pageAreaWidth = String('10');
  public pageAreaHeight = String('10');
  public pageDivH = Number(1);
  public pageDivW = Number(1);

  /**
   *Creates an instance of KYMW2401Component.
   * @param {KYMW00Model} kymw00Model
   * @param {ElementRef} elementRef
   * @param {PlessDialogServiceSub} dialogService
   * @param {CreateNewPageService} createNewPageService
   * @memberof KYMW2401Component
   */
  constructor(
    private kymw00Model: KYMW00Model,
    private elementRef: ElementRef,
    private dialogService: PlessDialogServiceSub,
    private createNewPageService: CreateNewPageService,
  ) {
    super(kymw00Model);
  }

  /**
   * 初期処理
   *
   * @memberof PhaseRegistComponent
   */
  public ngOnInit(): void {
    this.componentName = 'KYMW2401';
  }

  /**
   * 画面を閉じる
   *
   * @memberof KYMW2401Component
   */
  public eventCloseHandler(): void {
    this.closeFunction();
  }

  /**
   * 作成ボタン押下時処理
   *
   * @memberof KYMW2401Component
   */
  public eventCreateHandler(): void {
    const pageTemplateViewHelper = this.parent;
    if (this.getInputTemplateName() === '') {
      // {0}を入力してください。
      this.dialogService.openAlertGetMessage('E0250', ['テンプレート名']);
    } else if (pageTemplateViewHelper.hasTemplateName(this.getInputTemplateName())) {
      // 同一名称のテンプレートが既に登録されています。
      this.dialogService.openAlertGetMessage('E0251');
      // 項番2231 START 障害管理NO.I00458対応
      // } else if (this.getInputHeight() === 0 || this.getInputWidth() === 0) {
    } else if (this.getInputHeight() === 0 || this.getInputWidth() === 0 ||
      isNaN(this.getInputHeight()) || isNaN(this.getInputWidth())) {
      // 項番2231 END 障害管理NO.I00458対応
      // {0}を入力してください。
      this.dialogService.openAlertGetMessage('E0250', ['幅と高さは0以上の数字']);
    } else {
      this.createNewPageService.execute(pageTemplateViewHelper.kymw2400Model, this.createPageTemplateVO());

      this.eventCloseHandler();
    }
  }

  /**
   * PageTemplateVO作成
   *
   * @private
   * @returns {PageTemplateModel}
   * @memberof KYMW2401Component
   */
  private createPageTemplateVO(): PageTemplateModel {
    const vo: PageTemplateModel = new PageTemplateModel();
    vo.pageTemplateName = this.getInputTemplateName();
    // 項番2231 START 障害管理NO.I00458対応
    // vo.pageAreaX = Number(this.pageAreaX);
    // vo.pageAreaY = Number(this.pageAreaY);
    // vo.pageAreaHeight = this.getInputHeight();
    // vo.pageAreaWidth = this.getInputWidth();
    vo.pageAreaX = this.pageAreaX;
    vo.pageAreaY = this.pageAreaY;
    vo.pageAreaHeight = String(this.getInputHeight());
    vo.pageAreaWidth = String(this.getInputWidth());
    // 項番2231 END 障害管理NO.I00458対応
    vo.divH = this.pageDivH;
    vo.divW = this.pageDivW;
    return vo;
  }

  /**
   * テンプレート名取得
   *
   * @private
   * @returns {string}
   * @memberof KYMW2401Component
   */
  private getInputTemplateName(): string {
    return this.pageTemplateName;
  }

  /**
   * ページ領域高さ(mm)取得
   *
   * @private
   * @returns {number}
   * @memberof KYMW2401Component
   */
  private getInputHeight(): number {
    if (this.pageAreaHeight != null) {
      return Number(this.pageAreaHeight);
    }
    return 0;
  }

  /**
   * ページ領域幅(mm)取得
   *
   * @private
   * @returns {number}
   * @memberof KYMW2401Component
   */
  private getInputWidth(): number {
    if (this.pageAreaWidth != null) {
      return Number(this.pageAreaWidth);
    }
    return 0;
  }

}
